<template>
  <form class="mx-auto col-sm-12" @submit.prevent>
    <h3>Equipamento</h3>

    <div class="row p-2 mb-3" style="border: 1px solid #c7c6c6; border-radius: 5px;">
      <div
        class="form-group col-lg-6"
        :class="{ 'has-error': errors.has('serie') }"
        v-if="!equipment.id"
      >
        <label for="serie">{{ $t("serie") }}</label>
        <input
          type="text"
          id="serie"
          name="serie"
          class="form-control"
          :placeholder="$t('ph_serie')"
          v-model="equipment.serie"
          :hasErrors="errors.has('serie')"
          v-validate="'required'"
        />

        <small v-show="errors.has('serie')" class="form-text text-muted">
          {{ errors.first("serie") }}
        </small>
      </div>

      <div class="form-group col-lg-6">
        <label for="version">{{ $t("version") }}</label>
        <Combobox
          class="bg-white"
          name="version"
          :placeholder="$t('select_a_item')"
          :hasErrors="errors.has('version')"
          :options="equipmentVersions"
          :initial-value="equipment.version"
          label="VER_DSC"
          v-model="equipment.version"
          :reduce="(equipment) => equipment.id"
          v-validate="'required'"
        />

        <small v-show="errors.has('version')" class="form-text text-muted">
          {{ errors.first("version") }}
        </small>
      </div>

      <div class="form-group col-lg-6">
        <label for="client">{{ $t("client") }}</label>
        <Combobox
          :disabled="!equipment.id"
          class="bg-white"
          name="client"
          :placeholder="$t('select_a_item')"
          :hasErrors="errors.has('client')"
          :options="clients"
          :initial-value="equipment.client"
          label="CLI_DSC"
          v-model="equipment.client"
          :reduce="(client) => client.CLI_ID"
          v-validate="'required'"
        />

        <small v-show="errors.has('client')" class="form-text text-muted">
          {{ errors.first("client") }}
        </small>
      </div>
    </div>

    <h3>Dados do telefone</h3>

    <div class="row p-2 mb-3" style="border: 1px solid #c7c6c6; border-radius: 5px;">
      <div class="form-group col-lg-4">
        <label for="ddd">{{ $t("ddd") }}</label>
        <input
          type="text"
          id="ddd"
          name="ddd"
          class="form-control"
          :placeholder="$t('ph_ddd')"
          v-model="equipment.ddd"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="phone">{{ $t("phone") }}</label>
        <input
          type="text"
          id="phone"
          name="phone"
          class="form-control"
          :placeholder="$t('ph_phone')"
          v-model="equipment.phone"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="operator">{{ $t("operator") }}</label>
        <input
          type="text"
          id="operator"
          name="operator"
          class="form-control"
          :placeholder="$t('ph_operator')"
          v-model="equipment.operator"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="pin">{{ $t("pin") }}</label>
        <input
          type="text"
          id="pin"
          name="pin"
          class="form-control"
          :placeholder="$t('ph_pin')"
          v-model="equipment.pin"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="puk">{{ $t("puk") }}</label>
        <input
          type="text"
          id="puk"
          name="puk"
          class="form-control"
          :placeholder="$t('ph_puk')"
          v-model="equipment.puk"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="eqp_srt">{{ $t("eqp_srt") }}</label>
        <input
          type="text"
          id="eqp_srt"
          name="eqp_srt"
          class="form-control"
          :placeholder="$t('eqp_srt')"
          v-model="equipment.eqp_srt"
        />
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-4 col-sm-offset-2">
        <LoaderButton
          @click="save"
          :loading="isLoading"
        >
          {{ $t("save") }}
        </LoaderButton>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LoaderButton from "@/components/button/LoaderButton";
import Combobox from "@/components/shared/ComboBox";

export default {
  name: "ArenaEquipmentForm",
  components: {
    LoaderButton,
    Combobox,
  },

  data() {
    return {}
  },

  props: {
    equipment: {
      type: Object,
      default: () => ({
        id: undefined,
        serie: "",
        version: undefined,
        client: undefined,
        ddd: "",
        phone: "",
        operator: "",
        pin: "",
        puk: "",
        eqp_srt: ""
      }),
    },
  },

  computed: {
    ...mapState({
      isLoading: (state) => state.arena.isLoading,
      clients: (state) => state.arena.clients,
      equipmentVersions: (state) => state.arena.equipmentVersions,
    }),
  },

  methods: {
    ...mapActions("arena", ["createEquipment", "editEquipment"]),

    async save(evt, done) {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        const err = new Error(this.$t("invalid_form_fields"));

        this.$store.dispatch("notify/error", err);

        return
      }

      const { id, ...rest } = this.equipment;

      const result = id
        ? await this.editEquipment({ id, data: rest })
        : await this.createEquipment(rest)

      if (result) {
        this.$router.push({ name: "listarenaequipment" });
      }
    }
  },

  async mounted() {
    const { dispatch } = this.$store

    await Promise.all([
      dispatch("arena/fetchClients"),
      dispatch("arena/fetchArenaEquipmentVersions"),
    ]);

    if (!this.equipment.id) {
      this.equipment.client = 2
    }
  }
};
</script>
